/**
 * paypalOptions.js — Options partagées du PayPalScriptProvider (front).
 *
 * Centralise la configuration du chargement du SDK PayPal pour tous les
 * composants qui montent `<PayPalScriptProvider>` — jamais d'objet d'options
 * inline (anti-duplication §74, DRY §9).
 *
 * `currency: 'USD'` est explicite mais identique au défaut PayPal ; la devise de
 * l'ordre est de toute façon fixée côté serveur (transaction.controller.js
 * `currency_code: "USD"`). L'option SDK ne gouverne que l'affichage funding-source.
 *
 * Consommateurs : paypalModal.jsx, CartCheckoutModal.jsx.
 *
 * @returns {{ 'client-id': string, currency: string }}
 */
export const getPaypalScriptOptions = () => ({
  'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID || '',
  currency: 'USD',
});
